import { createFileRoute } from '@tanstack/react-router'
import { KelolaJabatan } from '../../../../components/KelolaJabatan'

export const Route = createFileRoute('/desa/$slug/dashboard/jabatan')({
  component: KelolaJabatan,
})
